import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_session9cytjmfbg8nd as get_session,
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
} from '../../sdk/UserSession.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  modify2eca96i8s7hc2 as modify,
  interceptWrite2xi6g5kl52xuu as interceptWrite,
} from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Owner3o3y53m8go5cb as Owner } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  _EmailAddress___init__impl__a6ugvr3vyholn0wwoi2 as _EmailAddress___init__impl__a6ugvr,
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
  _PhoneNumber___init__impl__slwhzyo93bblbw66x0 as _PhoneNumber___init__impl__slwhzy,
} from '../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { Addresscpovxna1tjmg as Address } from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { requestFile18ia1vr614wjr as requestFile } from '../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import {
  LocalFileyitm5ua4ch17 as LocalFile,
  Empty276q86o7r56ey as Empty,
  RemoteFileu6zpetu3ge6n as RemoteFile,
  Empty_instance19pnqi35t6rfs as Empty_instance,
} from '../components/files/attachmentFilePreview.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { awaitNotNullzd1xp1uu2voc as awaitNotNull } from '../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { takeLast2r8kr8e6g6hi7 as takeLast } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Draft43syxm8fng0j as Draft } from '../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_ssn1lut1lpw1ztmp as get_ssn,
  get_ownership2ob2423l2ny83 as get_ownership,
  get_legalFirstName2vgvsmypb78h2 as get_legalFirstName,
  get_legalLastName2t4vvvivshuwy as get_legalLastName,
  get_emailfkvak575ryut as get_email,
  get_phoneNumberpnx60x2fk8y as get_phoneNumber,
  get_address1u6nrhiuagd6j as get_address,
  get_title33i95i844yeoj as get_title,
  get_birthDate3aks5n4sb6fcg as get_birthDate,
} from '../../../../../crowpay-shared/com/crowpay/OwnerFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assertNotBlank3rcqh0n27fq5q as assertNotBlank,
  assertNotNull37l8a72xnu5i6 as assertNotNull,
  assert17rxqees4r4of as assert,
} from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { MutableRememberyv35kz5kmml7 as MutableRemember } from '../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  Companion_getInstance2v0f9t0g75gcs as Companion_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  align1ejncrrer3meh as align,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  title1nssp3ryhwuqj as title,
  smallBody2trfy14zwtona as smallBody,
  bodyBold2czwdzwknab0k as bodyBold,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from '../theming/Titles.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import {
  validategsg6go7eyi9d as validate,
  assertValidEmail3utsnuo6xdy4w as assertValidEmail,
  assertValidPhoneNumber13ya35cr3f72y as assertValidPhoneNumber,
} from '../../utils/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import {
  requiredField31yu7ndxhpyxkd as requiredField3,
  label287uhiq3m9m4z as label2,
  requiredLabel23q9lkacjaga4j as requiredLabel2,
} from '../components/label2.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { addressForm32k03uh8crpev as addressForm } from '../components/addressForm.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import { rangeTo5xinnemk0fd3 as rangeTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { renderFilePreview3fl8uuiu4tdzl as renderFilePreview } from '../components/files/renderFiles.mjs';
import { get_outlinedfhcs63de0vzu as get_outlined } from '../theming/appTheme.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
} from '../theming/buttons.mjs';
import {
  get_titlelss9nf4gv6ut as get_title_0,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ii9_1.di9_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.ii9_1.ei9_1.iah(tmp$ret$0.a6t_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp.rfw_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var self_0 = tmp_0;
  $this.ji9_1._v = it;
  var tmp0_email = self_0.e88_1;
  var tmp1_legalFirstName = self_0.h88_1;
  var tmp2_legalLastName = self_0.i88_1;
  var tmp3_address = self_0.j88_1;
  return it.f6t(VOID, tmp1_legalFirstName, tmp2_legalLastName, tmp0_email, VOID, tmp3_address);
}
function *_generator_invoke__zhh2q8_1($this, $this$interceptWrite, isMe, $completion) {
  if (isMe) {
    var tmp = modify($this.ki9_1.di9_1, CreateOrEditOwner$render$slambda$slambda_0($this.li9_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } else {
    var tmp_0 = modify($this.ki9_1.di9_1, CreateOrEditOwner$render$slambda$slambda_2($this.li9_1), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  $this$interceptWrite.oam(isMe);
  return Unit_instance;
}
var CreateOrEditOwner$render$slambda$slambdaClass;
function CreateOrEditOwner$render$slambda$slambda() {
  if (CreateOrEditOwner$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor($before) {
        this.ji9_1 = $before;
      }
      mi9(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.mi9(p1 instanceof Owner() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CreateOrEditOwner$render$slambda$slambdaClass = $;
  }
  return CreateOrEditOwner$render$slambda$slambdaClass;
}
function CreateOrEditOwner$render$slambda$slambda_0($before) {
  var i = new (CreateOrEditOwner$render$slambda$slambda())($before);
  var l = (it, $completion) => i.mi9(it, $completion);
  l.$arity = 1;
  return l;
}
var CreateOrEditOwner$render$slambda$slambdaClass_0;
function CreateOrEditOwner$render$slambda$slambda_1() {
  if (CreateOrEditOwner$render$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($before) {
        this.ni9_1 = $before;
      }
      mi9(it, $completion) {
        var tmp0_safe_receiver = this.ni9_1._v;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v6s_1;
        var tmp;
        var tmp_0 = tmp1_elvis_lhs;
        if ((tmp_0 == null ? null : new (EmailAddress())(tmp_0)) == null) {
          tmp = _EmailAddress___init__impl__a6ugvr('');
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp8_email = tmp;
        var tmp2_safe_receiver = this.ni9_1._v;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.t6s_1;
        var tmp9_legalFirstName = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
        var tmp4_safe_receiver = this.ni9_1._v;
        var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.u6s_1;
        var tmp10_legalLastName = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
        var tmp6_safe_receiver = this.ni9_1._v;
        var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.x6s_1;
        var tmp11_address = tmp7_elvis_lhs == null ? new (Address())() : tmp7_elvis_lhs;
        return it.f6t(VOID, tmp9_legalFirstName, tmp10_legalLastName, tmp8_email, VOID, tmp11_address);
      }
      s2(p1, $completion) {
        return this.mi9(p1 instanceof Owner() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CreateOrEditOwner$render$slambda$slambdaClass_0 = $;
  }
  return CreateOrEditOwner$render$slambda$slambdaClass_0;
}
function CreateOrEditOwner$render$slambda$slambda_2($before) {
  var i = new (CreateOrEditOwner$render$slambda$slambda_1())($before);
  var l = (it, $completion) => i.mi9(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = requestFile($this.oi9_1.pc(), listOf(['image/png', 'image/jpeg', 'application/pdf']), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  if (!(result == null)) {
    new (LocalFile())(result);
    // Inline function 'kotlin.also' call
    var this_0 = new (LocalFile())(result);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_session();
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp$ret$0 = tmp_0;
    var tmp_1 = this_0.ygb(LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(tmp$ret$0.vfw().off_1), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = $this.pi9_1.iah(this_0, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
var LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.qi9_1 = p0;
      }
      uao($completion) {
        return this.qi9_1.lfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2ContractorLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_issues($this.ri9_1.di9_1);
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    $this.ri9_1.hi9_1.oam(true);
    return Unit_instance;
  }
  $this.ri9_1.hi9_1.oam(false);
  var tmp_0 = awaitOnce($this.ri9_1.gi9_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var image = tmp_0;
  if (image instanceof LocalFile()) {
    var tmp_1 = await_0(image.xgb(), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = awaitNotNull(tmp_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    if (tmp_2) {
      var tmp_3 = modify($this.ri9_1.di9_1, CreateOrEditOwner$render$slambda$slambda_4(image), $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ri9_1.di9_1;
  var tmp_4 = await_0(this_1, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$2 = tmp_4;
  if (!contains(tmp$ret$2.z6s_1, '*')) {
    var tmp_5 = modify($this.ri9_1.di9_1, CreateOrEditOwner$render$slambda$slambda_6(), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
  }
  var tmp0_safe_receiver = $this.ri9_1.ci9_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.ri9_1.di9_1;
    var tmp_6 = await_0(this_2, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var tmp_7 = tmp0_safe_receiver(tmp_6, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
  }
  get_dialogStack().pgd();
  return Unit_instance;
}
var CreateOrEditOwner$render$slambda$slambdaClass_1;
function CreateOrEditOwner$render$slambda$slambda_3() {
  if (CreateOrEditOwner$render$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($image) {
        this.si9_1 = $image;
      }
      mi9(it, $completion) {
        var tmp = this.si9_1.mgb_1;
        return it.f6t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, ensureNotNull(tmp == null ? null : new (ServerFile())(tmp)).l2n_1);
      }
      s2(p1, $completion) {
        return this.mi9(p1 instanceof Owner() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CreateOrEditOwner$render$slambda$slambdaClass_1 = $;
  }
  return CreateOrEditOwner$render$slambda$slambdaClass_1;
}
function CreateOrEditOwner$render$slambda$slambda_4($image) {
  var i = new (CreateOrEditOwner$render$slambda$slambda_3())($image);
  var l = (it, $completion) => i.mi9(it, $completion);
  l.$arity = 1;
  return l;
}
var CreateOrEditOwner$render$slambda$slambdaClass_2;
function CreateOrEditOwner$render$slambda$slambda_5() {
  if (CreateOrEditOwner$render$slambda$slambdaClass_2 === VOID) {
    class $ {
      mi9(it, $completion) {
        return it.f6t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, '*****' + takeLast(it.z6s_1, 4));
      }
      s2(p1, $completion) {
        return this.mi9(p1 instanceof Owner() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CreateOrEditOwner$render$slambda$slambdaClass_2 = $;
  }
  return CreateOrEditOwner$render$slambda$slambdaClass_2;
}
function CreateOrEditOwner$render$slambda$slambda_6() {
  var i = new (CreateOrEditOwner$render$slambda$slambda_5())();
  var l = (it, $completion) => i.mi9(it, $completion);
  l.$arity = 1;
  return l;
}
function CreateOrEditOwner$ownership$lambda(it) {
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!(it === 0.0)) {
    tmp = it;
  } else {
    tmp = null;
  }
  return tmp;
}
function CreateOrEditOwner$ownership$lambda_0(it) {
  var tmp1_elvis_lhs = it == null ? null : numberToInt(it);
  return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
}
var CreateOrEditOwner$render$slambdaClass;
function CreateOrEditOwner$render$slambda() {
  if (CreateOrEditOwner$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ii9_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CreateOrEditOwner$render$slambdaClass = $;
  }
  return CreateOrEditOwner$render$slambdaClass;
}
function CreateOrEditOwner$render$slambda_0(this$0) {
  var i = new (CreateOrEditOwner$render$slambda())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var CreateOrEditOwner$render$slambdaClass_0;
function CreateOrEditOwner$render$slambda_1() {
  if (CreateOrEditOwner$render$slambdaClass_0 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateOrEditOwner$render$slambdaClass_0 = $;
  }
  return CreateOrEditOwner$render$slambdaClass_0;
}
function CreateOrEditOwner$render$slambda_2() {
  var i = new (CreateOrEditOwner$render$slambda_1())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function CreateOrEditOwner$render$lambda($this$shownWhen) {
  return !($this$shownWhen.daj(get_rawSession()) == null);
}
var CreateOrEditOwner$render$slambdaClass_1;
function CreateOrEditOwner$render$slambda_3() {
  if (CreateOrEditOwner$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $before) {
        this.ki9_1 = this$0;
        this.li9_1 = $before;
      }
      jhm($this$interceptWrite, isMe, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$interceptWrite, isMe), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof Signal() ? p1 : THROW_CCE();
        return this.jhm(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    CreateOrEditOwner$render$slambdaClass_1 = $;
  }
  return CreateOrEditOwner$render$slambdaClass_1;
}
function CreateOrEditOwner$render$slambda_4(this$0, $before) {
  var i = new (CreateOrEditOwner$render$slambda_3())(this$0, $before);
  var l = ($this$interceptWrite, isMe, $completion) => i.jhm($this$interceptWrite, isMe, $completion);
  l.$arity = 2;
  return l;
}
function CreateOrEditOwner$render$lambda$lambda(it) {
  return !(it instanceof Empty());
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.yb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var CreateOrEditOwner$render$lambda$slambdaClass;
function CreateOrEditOwner$render$lambda$slambda() {
  if (CreateOrEditOwner$render$lambda$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, $image) {
        this.oi9_1 = $$this$button;
        this.pi9_1 = $image;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateOrEditOwner$render$lambda$slambdaClass = $;
  }
  return CreateOrEditOwner$render$lambda$slambdaClass;
}
function CreateOrEditOwner$render$lambda$slambda_0($$this$button, $image) {
  var i = new (CreateOrEditOwner$render$lambda$slambda())($$this$button, $image);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var CreateOrEditOwner$render$slambdaClass_2;
function CreateOrEditOwner$render$slambda_5() {
  if (CreateOrEditOwner$render$slambdaClass_2 === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateOrEditOwner$render$slambdaClass_2 = $;
  }
  return CreateOrEditOwner$render$slambdaClass_2;
}
function CreateOrEditOwner$render$slambda_6() {
  var i = new (CreateOrEditOwner$render$slambda_5())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var CreateOrEditOwner$render$slambdaClass_3;
function CreateOrEditOwner$render$slambda_7() {
  if (CreateOrEditOwner$render$slambdaClass_3 === VOID) {
    class $ {
      constructor(this$0) {
        this.ri9_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CreateOrEditOwner$render$slambdaClass_3 = $;
  }
  return CreateOrEditOwner$render$slambdaClass_3;
}
function CreateOrEditOwner$render$slambda_8(this$0) {
  var i = new (CreateOrEditOwner$render$slambda_7())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var CreateOrEditOwnerClass;
function CreateOrEditOwner() {
  if (CreateOrEditOwnerClass === VOID) {
    class $ {
      constructor(owner, onSubmit) {
        onSubmit = onSubmit === VOID ? null : onSubmit;
        this.bi9_1 = owner;
        this.ci9_1 = onSubmit;
        var tmp = this;
        var tmp0_elvis_lhs = this.bi9_1;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          var tmp1_email = _EmailAddress___init__impl__a6ugvr('');
          var tmp2_phoneNumber = _PhoneNumber___init__impl__slwhzy('');
          var tmp3_address = new (Address())();
          tmp_0 = new (Owner())(VOID, '', '', tmp1_email, tmp2_phoneNumber, tmp3_address, VOID, '', VOID, 100, null, null);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp.di9_1 = validated(Draft(tmp_0));
        var tmp_1 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.di9_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_2 = serializerOrContextual(createKType(getKClass(Owner()), arrayOf([]), false));
        var tmp$ret$0 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$0);
        var tmp$ret$2 = get_ssn(it);
        var tmp$ret$3 = lensPath(this_0, tmp$ret$2);
        tmp_1.ei9_1 = assertNotBlank(tmp$ret$3);
        var tmp_3 = this;
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_1 = this.di9_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_4 = serializerOrContextual(createKType(getKClass(Owner()), arrayOf([]), false));
        var tmp$ret$4 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$4);
        var tmp$ret$6 = get_ownership(it_0);
        var tmp_5 = lensPath(this_1, tmp$ret$6);
        var tmp_6 = CreateOrEditOwner$ownership$lambda;
        tmp_3.fi9_1 = tmp_5.vak(tmp_6, CreateOrEditOwner$ownership$lambda_0);
        var tmp_7 = this;
        tmp_7.gi9_1 = MutableRemember().tak(VOID, VOID, VOID, VOID, ($this$MutableRemember) => {
          var tmp0_safe_receiver = $this$MutableRemember.daj(this.di9_1).d6t_1;
          var tmp;
          var tmp_0 = tmp0_safe_receiver;
          if ((tmp_0 == null ? null : new (ServerFile())(tmp_0)) == null) {
            tmp = null;
          } else {
            var tmp_1 = tmp0_safe_receiver;
            // Inline function 'kotlin.let' call
            var it = (tmp_1 == null ? null : new (ServerFile())(tmp_1)).l2n_1;
            tmp = new (RemoteFile())(_ServerFile___get_location__impl__ddyqaq(it));
          }
          var tmp1_elvis_lhs = tmp;
          return tmp1_elvis_lhs == null ? Empty_instance : tmp1_elvis_lhs;
        });
        this.hi9_1 = Signal().hak(false);
      }
      wd6(_this__u8e3s4) {
        launch(_this__u8e3s4, VOID, VOID, CreateOrEditOwner$render$slambda_0(this));
        var tmp = _this__u8e3s4.kbb(get_unpadded(_this__u8e3s4), get_scrolling(_this__u8e3s4));
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(CreateOrEditOwner$render$slambda_2());
        var tmp_0 = view.kbb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(55)), align(view, Align_Center_getInstance(), Align_Stretch_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc(), 2.0);
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_0.hbb(p_1, view_1);
        var tmp_1 = view_0.jbb(DialogSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        view_2.gba(get_AppDimensions().yg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(true);
        title(view_3, 'Business Owner Information');
        smallBody(view_3, "If someone other than the business owner is completing this registration, please provide the owner's information below. The owner will receive a direct notification confirming this account was created on their behalf.");
        var tmp_2 = view_3.kbb(shownWhen(view_3, VOID, CreateOrEditOwner$render$lambda), get_compact(view_3));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.gbb(p_4, view_4);
        view_4.zbm(false);
        var tmp_3 = get_centered(view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Checkbox())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        var before = {_v: null};
        var tmp_4 = Signal().hak(false);
        view_5.zah(view_5.ebk_1, interceptWrite(tmp_4, CreateOrEditOwner$render$slambda_4(this, before)));
        view_4.hbb(p_5, view_5);
        view_4.lbb(tmp_3, view_5);
        view_4.lbb(get_centered(view_4), bodyBold(view_4, 'I am the business owner \u2014 use my information'));
        view_3.hbb(p_4, view_4);
        view_3.lbb(tmp_2, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_6 = view_3.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_3 : tmp0_elvis_lhs_6;
        view_3.gbb(p_6, view_6);
        view_6.zbm(false);
        var tmp_5 = get_expanding(view_6);
        view_6.lbb(tmp_5, requiredField3(view_6, 'Legal First Name', "Enter the owner's legal first name.", ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.di9_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Owner()), arrayOf([]), false));
          var tmp$ret$10 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$10);
          var tmp$ret$12 = get_legalFirstName(it);
          var tmp$ret$13 = lensPath(this_0, tmp$ret$12);
          var firstName = assertNotBlank(tmp$ret$13);
          var tmp_0 = validate($this$requiredField3, firstName, ($this$validate) => $this$validate.daj(this.hi9_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = 'John';
          view.cbs(Companion_getInstance().sd5_1);
          view.zah(view.icn_1, firstName);
          $this$requiredField3.hbb(p, view);
          $this$requiredField3.lbb(tmp_0, view);
          var tmp_1 = get_issues(firstName);
          return issueText($this$requiredField3, tmp_1, VOID, ($this$issueText) => $this$issueText.daj(this.hi9_1));
        }));
        var tmp_6 = get_expanding(view_6);
        view_6.lbb(tmp_6, requiredField3(view_6, 'Legal Last Name', "Enter the owner's legal last name.", ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.di9_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Owner()), arrayOf([]), false));
          var tmp$ret$19 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$19);
          var tmp$ret$21 = get_legalLastName(it);
          var tmp$ret$22 = lensPath(this_0, tmp$ret$21);
          var lastName = assertNotBlank(tmp$ret$22);
          var tmp_0 = validate($this$requiredField3, lastName, ($this$validate) => $this$validate.daj(this.hi9_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = 'Smith';
          view.cbs(Companion_getInstance().sd5_1);
          view.zah(view.icn_1, lastName);
          $this$requiredField3.hbb(p, view);
          $this$requiredField3.lbb(tmp_0, view);
          var tmp_1 = get_issues(lastName);
          return issueText($this$requiredField3, tmp_1, VOID, ($this$issueText) => $this$issueText.daj(this.hi9_1));
        }));
        view_3.hbb(p_6, view_6);
        requiredField3(view_3, "Owner's Email Address", "We'll send the owner a confirmation that this account was registered. Use their direct email \u2014 not a shared inbox.", ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.di9_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Owner()), arrayOf([]), false));
          var tmp$ret$32 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$32);
          var tmp$ret$34 = get_email(it);
          var tmp$ret$35 = lensPath(this_0, tmp$ret$34);
          var email = assertValidEmail(tmp$ret$35);
          var tmp_0 = validate($this$requiredField3, email, ($this$validate) => $this$validate.daj(this.hi9_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'owner@business.com';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.zah(view.icn_1, email);
          $this$requiredField3.hbb(p, view);
          $this$requiredField3.lbb(tmp_0, view);
          var tmp_1 = get_issues(email);
          return issueText($this$requiredField3, tmp_1, VOID, ($this$issueText) => $this$issueText.daj(this.hi9_1));
        });
        requiredField3(view_3, "Owner's Mobile Number", "We'll send a text confirmation to the owner when registration is complete. Mobile number required.", ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.di9_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Owner()), arrayOf([]), false));
          var tmp$ret$41 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$41);
          var tmp$ret$43 = get_phoneNumber(it);
          var tmp$ret$44 = lensPath(this_0, tmp$ret$43);
          var phone = assertValidPhoneNumber(tmp$ret$44);
          var tmp_0 = validate($this$requiredField3, phone, ($this$validate) => $this$validate.daj(this.hi9_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
          // Inline function 'kotlin.apply' call
          var this_1 = new (PhoneNumberInput())($this$requiredField3);
          this_1.vcl('(123) 456-7890');
          $this$requiredField3.zah(this_1.c2a(), phone);
          $this$requiredField3.lbb(tmp_0, this_1);
          var tmp_1 = get_issues(phone);
          return issueText($this$requiredField3, tmp_1, VOID, ($this$issueText) => $this$issueText.daj(this.hi9_1));
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Space())(view_3.pc(), 0.5);
        var tmp0_elvis_lhs_7 = view_3.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_3 : tmp0_elvis_lhs_7;
        view_3.gbb(p_7, view_7);
        view_3.hbb(p_7, view_7);
        label2(view_3, 'Home Address', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.di9_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Owner()), arrayOf([]), false));
          var tmp$ret$51 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$51);
          var tmp$ret$53 = get_address(it);
          var address = lensPath(this_0, tmp$ret$53);
          return addressForm($this$label2, address, VOID, VOID, VOID, ($this$addressForm) => $this$addressForm.daj(this.hi9_1));
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Space())(view_3.pc());
        var tmp0_elvis_lhs_8 = view_3.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_3 : tmp0_elvis_lhs_8;
        view_3.gbb(p_8, view_8);
        view_3.hbb(p_8, view_8);
        boldSubTitle(view_3, 'Identity & Verification');
        smallBody(view_3, 'Required by federal banking regulations to verify your identity as an account holder. All information is encrypted and stored securely.');
        requiredField3(view_3, 'Owner Title', 'Job title or role in the business.', ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.di9_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Owner()), arrayOf([]), false));
          var tmp$ret$58 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$58);
          var tmp$ret$60 = get_title(it);
          var tmp$ret$61 = lensPath(this_0, tmp$ret$60);
          var ownerTitle = assertNotBlank(tmp$ret$61);
          var tmp_0 = validate($this$requiredField3, ownerTitle, ($this$validate) => $this$validate.daj(this.hi9_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'Managing Member';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance().sd5_1);
          view.zah(view.icn_1, ownerTitle);
          $this$requiredField3.hbb(p, view);
          $this$requiredField3.lbb(tmp_0, view);
          var tmp_1 = get_issues(ownerTitle);
          return issueText($this$requiredField3, tmp_1, VOID, ($this$issueText) => $this$issueText.daj(this.hi9_1));
        });
        requiredField3(view_3, 'Date of Birth', 'Used for identity verification.', ($this$requiredField3) => {
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.di9_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Owner()), arrayOf([]), false));
          var tmp$ret$67 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$67);
          var tmp$ret$69 = get_birthDate(it);
          var tmp$ret$70 = lensPath(this_0, tmp$ret$69);
          var dob = assertNotNull(tmp$ret$70);
          var tmp_0 = validate($this$requiredField3, dob, ($this$validate) => $this$validate.daj(this.hi9_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (LocalDateField())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          view.zah(view.nby_1, dob);
          $this$requiredField3.hbb(p, view);
          $this$requiredField3.lbb(tmp_0, view);
          var tmp_1 = get_issues(dob);
          return issueText($this$requiredField3, tmp_1, VOID, ($this$issueText) => $this$issueText.daj(this.hi9_1));
        });
        requiredField3(view_3, 'Social Security Number', 'Encrypted and stored securely. Required for U.S. individuals.', ($this$requiredField3) => {
          var tmp = validate($this$requiredField3, this.ei9_1, ($this$validate) => $this$validate.daj(this.hi9_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          var value = 'XXX-XX-XXXX';
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = value;
          view.cbs(Companion_getInstance().ad6_1);
          view.zah(view.icn_1, this.ei9_1);
          $this$requiredField3.hbb(p, view);
          return $this$requiredField3.lbb(tmp, view);
        });
        requiredField3(view_3, 'Percentage of Ownership', "Enter this owner's ownership percentage as a whole number. Only owners with 25% or more ownership are required to be listed..", ($this$requiredField3) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (NumberInput())($this$requiredField3.pc());
          var tmp0_elvis_lhs = $this$requiredField3.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredField3 : tmp0_elvis_lhs;
          $this$requiredField3.gbb(p, view);
          // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view.vb5_1.bb4_1.kb7_1.placeholder = '25';
          view.cbs(Companion_getInstance().ud5_1);
          view.ec6(rangeTo(25.0, 100.0));
          view.zah(view.zc5_1, this.fi9_1);
          $this$requiredField3.hbb(p, view);
          return view;
        });
        requiredLabel2(view_3, 'Upload Government ID (Primary Admin Only)', 'Only required for the individual setting up the account. Accept: PDF, JPG, PNG.', ($this$requiredLabel2) => {
          var image = assert(this.gi9_1, 'Cannot be blank', VOID, VOID, CreateOrEditOwner$render$lambda$lambda);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Button())($this$requiredLabel2.pc());
          var tmp0_elvis_lhs = $this$requiredLabel2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$requiredLabel2 : tmp0_elvis_lhs;
          $this$requiredLabel2.gbb(p, view);
          var tmp = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(6), get_rem(6));
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          var $this$preview = view_0;
          reactiveScope($this$preview, ($this$reactiveScope) => {
            $this$preview.bba();
            renderFilePreview($this$preview, $this$reactiveScope.daj(image), get_rem(6));
            var tmp = $this$preview.kbb(get_centered($this$preview), get_outlined($this$preview));
            // Inline function 'com.crowpay.views.theming.body' call
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            var this_0 = $this$preview;
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (TextView())(this_0.pc());
            var tmp0_elvis_lhs = this_0.ebb_1;
            var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
            this_0.gbb(p, view);
            view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
            var tmp_0 = KMutableProperty0();
            var tmp_1 = TextView$_get_shown_$ref_kipsub(view);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_1 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(view));
            reactiveScope(view, ($this$reactiveScope) => {
              var tmp$ret$84 = equals($this$reactiveScope.daj(image), Empty_instance);
              this_1.set(tmp$ret$84);
              return Unit_instance;
            });
            view.dbs(Align_Center_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
            var value = 'Image\nUpload';
            var tmp_2 = view.vb5_1;
            var tmp_3;
            // Inline function 'kotlin.text.isEmpty' call
            if (charSequenceLength(value) === 0) {
              tmp_3 = '\xA0';
            } else {
              tmp_3 = value;
            }
            tmp_2.hbu(tmp_3);
            this_0.hbb(p, view);
            $this$preview.lbb(tmp, view);
            return Unit_instance;
          });
          view.hbb(p_0, view_0);
          view.lbb(tmp, view_0);
          onClick(view, VOID, VOID, CreateOrEditOwner$render$lambda$slambda_0(view, image));
          $this$requiredLabel2.hbb(p, view);
          return view;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_9 = view_3.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_3 : tmp0_elvis_lhs_9;
        view_3.gbb(p_9, view_9);
        view_9.zbm(false);
        var tmp_7 = get_expanding(view_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Space())(view_9.pc());
        var tmp0_elvis_lhs_10 = view_9.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
        view_9.gbb(p_10, view_10);
        view_9.hbb(p_10, view_10);
        view_9.lbb(tmp_7, view_10);
        var tmp_8 = get_secondaryButton(view_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (Button())(view_9.pc());
        var tmp0_elvis_lhs_11 = view_9.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
        view_9.gbb(p_11, view_11);
        specCenteredText(view_11, 'Cancel');
        onClick(view_11, VOID, VOID, CreateOrEditOwner$render$slambda_6());
        view_9.hbb(p_11, view_11);
        view_9.lbb(tmp_8, view_11);
        var tmp_9 = get_primaryButton(view_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (Button())(view_9.pc());
        var tmp0_elvis_lhs_12 = view_9.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_9 : tmp0_elvis_lhs_12;
        view_9.gbb(p_12, view_12);
        specCenteredText(view_12, 'Save');
        onClick(view_12, VOID, VOID, CreateOrEditOwner$render$slambda_8(this));
        view_9.hbb(p_12, view_12);
        view_9.lbb(tmp_9, view_12);
        view_3.hbb(p_9, view_9);
        view_2.hbb(p_3, view_3);
        view_0.hbb(p_2, view_2);
        view_0.lbb(tmp_1, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (Space())(view_0.pc(), 2.0);
        var tmp0_elvis_lhs_13 = view_0.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_0 : tmp0_elvis_lhs_13;
        view_0.gbb(p_13, view_13);
        view_0.hbb(p_13, view_13);
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wcv = get_title_0;
    initMetadataForClass($, 'CreateOrEditOwner', VOID, VOID, [Page()]);
    CreateOrEditOwnerClass = $;
  }
  return CreateOrEditOwnerClass;
}
//region block: exports
export {
  CreateOrEditOwner as CreateOrEditOwner1qdnuxw2ttt7k,
};
//endregion

//# sourceMappingURL=CreateOrEditOwner.mjs.map
